export class TotalSkillTopicPlaylistModel {
  topic: number = 0
  playlist: number = 0
  skill: number = 0
  data: any = [] // any array model of skill, topic and playlist
}
